import { Box, ButtonProps, forwardRef, IconButton, rem, Tooltip } from '@bonusly/design-system';

import { useActionInput } from '../../context';

interface DecorationButtonProps extends ButtonProps {
	label: string;
}

export const DecorationButton = forwardRef<DecorationButtonProps, 'div'>(({ label, onClick, ...rest }, ref) => {
	const { startDraft } = useActionInput();

	return (
		<Box ref={ref}>
			<Tooltip label={label}>
				<IconButton
					aria-label={label}
					borderRadius={rem(10)}
					boxSize={rem(40)}
					color="gray.700"
					fontSize={rem(24)}
					onClick={(e) => {
						startDraft();
						onClick?.(e);
					}}
					_hover={{
						background: 'gray.25',
					}}
					{...rest}
				/>
			</Tooltip>
		</Box>
	);
});
